module.exports = __webpack_public_path__ + "img/cloth_g1_item_02.c673c494.svg";